/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import { IShotView } from "../../../../types/aig/server";
import { Callback, IErrorObject } from "../../../../types/platform/universe";

import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";

import { GridViewComponent } from "../../platform/base/components/gridview.component";
import { ShotdataAvgDialogComponent } from "./shotdata-avg-dialog/shotdata-avg-dialog.component";
import { ShotdataDialogComponent } from "./shotdata-dialog/shotdata-dialog.component";

import { ConfirmCreateShotAvgDialogComponent } from "./confirm-create-shotavg-dialog/confirm-create-shotavg-dialog.component";

import { ConditionDialogComponent } from "./condition-dialog/condition-dialog.component";

import { Overlay } from "@angular/cdk/overlay";
import { MatPaginator } from "@angular/material/paginator";
import { ActivatedRoute } from "@angular/router";
import { YesNoDialogComponent } from "../../platform/base/components/yes-no-dialog/yes-no-dialog.component";
import { SessionService } from "../../platform/base/services/session.service";
import { MessageDialogComponent } from "../base/components/message-dialog/message-dialog.component";
import { Errors } from "../base/library/errors";
import { UpdateListComponent } from "../shot/list/update-dialog/update-dialog.component";
import { ShotScoreService } from "../shot/shot-score.service";
import { DescriptionDialogComponent } from "./description-dialog/description-dialog.component";
import { ShotdataService } from "./shotdata.service";

import _ from "lodash";
import moment from "moment";
import {
  calculatePartByMesure,
  getAvgParts,
  getSmParts,
  updateModel,
} from "../../utils/evaluationMethod";

// i18n
import { TranslateService } from "@ngx-translate/core";

interface IRange {
  from: number;
  to: number;
}

interface IPeriod {
  from: Date;
  to: Date;
}

interface IField {
  create: IPeriod;
  extends: boolean;
  sortType: string;
  name: string;
  username: string;
  nickname: string;
  age: IRange;
  like: string;
  score: IRange;
  aria: string;
  gender: string;
  status: any[];
  club: number;
  prizm: IRange;
  prizmFields: number;
  sm: IRange;
  smPosition: number;
  smPhase: number;
  avgShot: boolean;
}

/**
 * Shot
 *
 * @since 0.01
 */
@Component({
  selector: "shotdata",
  templateUrl: "./shotdata.component.html",
  styleUrls: ["./shotdata.component.css"],
})
export class ShotdataComponent
  extends GridViewComponent
  implements OnInit, OnDestroy
{
  //	@ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("paginator") paginator: MatPaginator;

  public _ = _;

  public default_field: IField = {
    extends: false,
    sortType: "create",
    create: {
      from: new Date(
        new Date().getFullYear() - 1,
        new Date().getMonth(),
        new Date().getDate()
      ),
      to: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()
      ),
    },
    name: "",
    username: "",
    nickname: "",
    age: { from: 0, to: 100 },
    score: { from: 1, to: 100 },
    aria: "",
    gender: "0",
    status: [],
    club: 0,
    like: "0",
    prizm: { from: 0, to: 0 },
    prizmFields: -1,
    sm: { from: 0, to: 0 },
    smPosition: -1,
    smPhase: -1,
    avgShot: false,
  };

  public current_field: IField = {
    extends: false,
    sortType: "create",
    create: {
      from: new Date(
        new Date().getFullYear() - 1,
        new Date().getMonth(),
        new Date().getDate()
      ),
      to: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()
      ),
    },
    name: "",
    username: "",
    nickname: "",
    age: { from: 0, to: 100 },
    score: { from: 1, to: 100 },
    aria: "",
    gender: "0",
    status: [],
    club: 0,
    like: "0",
    prizm: { from: 0, to: 0 },
    prizmFields: -1,
    sm: { from: 0, to: 0 },
    smPosition: -1,
    smPhase: -1,
    avgShot: false,
  };

  public fields: any = {};

  public conditions: { name: string; value: string }[] = [];
  public selected_condition: string;
  public method: string = "AIGIA標準メソッド";
  public selectedShot: any = null;
  public isHasModel = false;
  public matDialogRef: MatDialogRef<any> = null;
  public device: string;

  public conditions_panels = {
    open_find: true,
    open_sort: true,
    open_prizm: true,
    open_sm: true,
  };

  public prizm = [
    { name: "弾道データを選択", value: -1 },
    { name: "トータル(yard)", value: 0 },
    { name: "キャリー(yard)", value: 2 },
    { name: "ミート率", value: 6 },
    { name: "ヘッドスピード", value: 4 },
    { name: "ボールスピード", value: 5 },
    { name: "バックスピン", value: 9 },
    { name: "打ち出し角", value: 7 },
    { name: "サイドスピン", value: 10 },
    { name: "左右ブレ", value: 8 },
  ];

  public position = [
    { name: "骨格を選択", value: -1 },
    { name: "前傾ライン", value: 0 },
    { name: "センターライン", value: 1 },
    { name: "ネックポジション", value: 2 },
    { name: "ライトライン", value: 3 },
    { name: "レフトライン", value: 4 },
    { name: "センターポジション", value: 5 },
    { name: "右膝の角度", value: 6 },
    { name: "左膝の角度", value: 8 },
  ];

  public phase = [
    { name: "フェーズを選択", value: -1 },
    { name: "AD(アドレス)", value: 0 },
    { name: "HB(ハーフバック)", value: 1 },
    { name: "TP(トップ)", value: 2 },
    { name: "HD(ハーフダウン)", value: 3 },
    { name: "IM(インパクト)", value: 4 },
    { name: "HF(ハーフフォロー)", value: 5 },
    { name: "FN(フィニッシュ)", value: 6 },
  ];

  public clubs: { name: string; value: any }[] = [];

  private _likes: { name: string; value: any }[] = [
    { name: "全て", value: "0" },
    { name: "お気に入り", value: "1" },
  ];

  public likes: { name: string; value: any }[] = [];

  private _sortFields: { name: string; value: any }[] = [
    { name: "スイング日時", value: "create" },
    { name: "スコア", value: "platform.description.score" },
    { name: "クラブ種類", value: "platform.description.club" },
    { name: "ニックネーム", value: "platform.content.nickname" },
  ];

  public sortFields: { name: string; value: any }[] = [];

  private _sortFieldsShort: { name: string; value: any }[] = [
    { name: "日時", value: "create" },
    { name: "スコア", value: "platform.description.score" },
    { name: "クラブ", value: "platform.description.club" },
    //	{name: "名前", value: "platform.content.nickname"},
    { name: "名前", value: "owner.content.nickname" },
  ];

  public sortFieldsShort: { name: string; value: any }[] = [];

  public uploadfile: string = "";

  public isCustomer: boolean = false;

  public isRelated: boolean = false;

  public is_new_version: boolean = true;
  public pageIndex: number;
  public selectedAvgInputShots = [];

  /**
   *
   * @param session
   * @param overlay
   * @param shotsService
   * @param matDialog
   * @param snackbar
   * @param shotscore
   * @param activatedRoute
   */
  constructor(
    public session: SessionService,
    protected overlay: Overlay,
    public shotsService: ShotdataService,
    protected matDialog: MatDialog,
    protected snackbar: MatSnackBar,
    public shotscore: ShotScoreService,
    private activatedRoute: ActivatedRoute,
    public translate: TranslateService
  ) {
    super(session, matDialog);
    this.service = shotsService;
    this.size = 20;
  }

  /**
   * リストビューデコレータ
   * @param object
   */
  public toListView(object: any): any {
    object.cols = 1;
    object.rows = 1;
    return object;
  }

  /**
   * ビューデコレータ
   *
   * @param data デコレーション対象
   */
  public toView(data: any): any {
    return data;
  }

  /**
   * トランスフォーマー
   * @param data トランスフォーム対象
   */
  public confirmToModel(data: any): any {
    return data;
  }

  /**
   * todo
   */
  private buildSort(fields: IField): any {
    let result = this.makeField({}, "create", -1);
    if (fields.sortType) {
      result = this.makeField({}, fields.sortType, -1);
    }
    return result;
  }

  /**
   * todo
   */
  private makeField(object: any, name: string, value: any): any {
    object[name] = value;
    return object;
  }

  /**
   * todo
   */
  private between(field: string, range: IRange): any {
    let result: any = null;
    const greater: number = this.greater(range);
    const lesser: number = this.lesser(range);

    if (greater === lesser) {
      result = this.makeField({}, field, { $eq: greater });
    } else {
      const from: any = this.makeField({}, field, { $gte: lesser });
      const to: any = this.makeField({}, field, { $lte: greater });
      result = { $and: [from, to] };
    }

    return result;
  }

  /**
   * todo
   */
  private smPosition(no: number): string {
    let result: string = "";
    switch (no) {
      case 0:
        result = "前傾角度";
        break;
      case 1:
        result = "背骨の傾き";
        break;
      case 2:
        result = "首元の動き";
        break;
      case 3:
        result = "右腰の動き";
        break;
      case 4:
        result = "左腰の動き";
        break;
      case 5:
        result = "重心の動き_正面";
        break;
      case 6:
        result = "右膝の角度";
        break;
      case 7:
        result = "手元の浮き";
        break;
      case 8:
        result = "左膝の角度";
        break;
      case 9:
        result = "頭の動き";
        break;
      case 10:
        result = "両肩の傾き_正面";
        break;
      case 11:
        result = "重心の動き_後方";
        break;
      case 12:
        result = "グリップ位置";
        break;
      case 13:
        result = "手首軌道";
        break;
      case 14:
        result = "腰の開き";
        break;
      case 15:
        result = "肩の開き";
        break;
      default:
    }
    return result;
  }

  /**
   * todo
   */
  private smPhase(no: number): string {
    let result: string = "";
    switch (no) {
      case 0:
        result = "address";
        break;
      case 1:
        result = "backswing";
        break;
      case 2:
        result = "top";
        break;
      case 3:
        result = "halfdown";
        break;
      case 4:
        result = "impact";
        break;
      case 5:
        result = "follow";
        break;
      case 6:
        result = "finish";
        break;
      default:
    }
    return result;
  }

  /**
   * todo
   */
  private smFields(position: string, phase: string): string {
    return "sm." + position + "." + phase + ".metrics";
  }

  /**
   * todo
   */
  private metrics(position: string, phase: string, range: IRange): any {
    const field: string = this.smFields(position, phase);
    return this.between(field, range);
  }

  /**
   * @returns none
   */
  public isYard(shot: any): string {
    let result: string = "-";
    if (shot) {
      if (shot.prizm) {
        if (shot.prizm.DataList) {
          if (shot.prizm.DataList.length > 0) {
            result = shot.prizm.DataList[0].Value;
          }
        }
      }
    }
    return result;
  }

  /**
   * todo
   */
  private period(field: string, range: IPeriod): any {
    const from: Date = range.from;
    const to: Date = range.to;
    const after: any = this.makeField({}, field, { $gte: from });
    const before: any = this.makeField({}, field, { $lte: to });
    return { $and: [after, before], convert_to: "period" };
  }

  /**
   * todo
   */
  private valueRange(range: IRange): boolean {
    return Boolean(range.from) && Boolean(range.to);
  }

  /**
   * todo
   */
  private valuePeriod(range: IPeriod): boolean {
    return Boolean(range.from) && Boolean(range.to);
  }

  /**
   * todo
   */
  private greater(range: IRange): number {
    let result = range.from;
    if (result < range.to) {
      result = range.to;
    }
    return result;
  }

  /**
   * todo
   */
  private lesser(range: IRange): number {
    let result = range.from;
    if (result > range.to) {
      result = range.to;
    }
    return result;
  }

  /**
   * todo
   */
  private buildQuery(fields: IField): any {
    let result: any = {};
    const conditions: any[] = [];

    if (this.valuePeriod(fields.create)) {
      conditions.push(this.period("create", fields.create));
    }

    if (fields.name) {
      conditions.push({ name: { $regex: fields.name } });
    }

    if (fields.nickname) {
      conditions.push({
        "platform.content.nickname": { $regex: fields.nickname },
      });
      //		conditions.push({"owner.content.nickname": {$regex: fields.nickname}});
    }

    if (fields.username) {
      conditions.push({ "owner.username": { $regex: fields.username } });
    }

    if (this.valueRange(fields.age)) {
      conditions.push(this.between("owner.content.age", fields.age));
    }

    if (fields.gender !== "0") {
      conditions.push({ "owner.content.gender": fields.gender });
    }

    if (fields.club !== 0) {
      conditions.push({ "platform.description.club": fields.club });
    }

    if (this.valueRange(fields.score)) {
      conditions.push(this.between("platform.description.score", fields.score));
    }

    if (fields.like !== "0") {
      const like: boolean = fields.like === "1";
      conditions.push({ "platform.description.like": like });
    }

    if (fields.avgShot) {
      conditions.push({ "platform.description.avg_shot": true });
    }

    const prizmFieldsNo: number = fields.prizmFields;
    if (prizmFieldsNo >= 0) {
      if (this.valueRange(fields.prizm)) {
        conditions.push(
          this.between(
            "prizm.DataList." + prizmFieldsNo + ".Value",
            fields.prizm
          )
        );
      }
    }

    const position: string = this.smPosition(fields.smPosition);
    if (position !== "") {
      const phase: string = this.smPhase(fields.smPhase);
      if (phase !== "") {
        if (this.valueRange(fields.sm)) {
          conditions.push(this.metrics(position, phase, fields.sm));
        }
      }
    }

    if (conditions.length > 0) {
      result = { $and: conditions };
    }
    result.is_has_model = this.isHasModel;

    console.log("buildQuery", result);

    return result;
  }

  /**
   * @returns none
   */
  private initSelect(): void {
    this.conditions = [];
    const keys = Object.keys(this.fields);
    keys.forEach((key) => {
      const field = { name: key, value: key };
      this.conditions.push(field);
    });
  }

  /**
   * @returns none
   */
  private conditionDialog(
    callback: (error: IErrorObject, data: any) => void
  ): void {
    const dialog: MatDialogRef<any> = this.matDialog.open(
      ConditionDialogComponent,
      {
        width: "50%",
        minWidth: "320px",
        height: "fit-content",
        data: { name: "" },
        disableClose: true,
      }
    );

    dialog.beforeClosed().subscribe((result: object): void => {});

    dialog.afterClosed().subscribe((result: object): void => {
      callback(null, result);
    });
  }

  /**
   * メッセージ表示
   * @param message
   */
  private messageBar(message: string): void {
    if (message) {
      this.snackbar.open(message, "Close", {
        duration: 2000,
        panelClass: ["message-snackbar"],
      });
    }
  }

  /**
   * todo
   */
  protected errorDialog(
    error: IErrorObject,
    callback: (result: any) => void = (error: IErrorObject) => {}
  ): void {
    if (error) {
      const dialog: MatDialogRef<any> = this.matDialog.open(
        MessageDialogComponent,
        {
          width: "30%",
          minWidth: "320px",
          height: "fit-content",
          data: {
            content: {
              title: "Error.",
			  message: error.message.replace(/。/g, "。<br>"),
              tag: error.tag,
            },
          },
          disableClose: true,
        }
      );

      dialog.afterClosed().subscribe((result: any): void => {
        callback(result);
      });
    }
  }

  /**
   * @returns none
   */
  public selectCondition(): void {
    this.onFind();
  }

  /**
   * @returns none
   */
  public newCondition(): void {
    this.conditionDialog((error: IErrorObject, result: any): void => {
      if (!error) {
        if (result) {
          const new_name = result.name;
          const exist = this.fields.hasOwnProperty(new_name);
          if (!exist) {
            try {
              const condition = this.current_field;
              const cloned_condition = JSON.parse(JSON.stringify(condition));
              cloned_condition.extends = true;
              this.fields[result.name] = cloned_condition;
              this.selected_condition = new_name;
              this.initSelect();
              this.saveCondition();
            } catch (error: any) {
              this.errorDialog(
                Errors.generalError(error.code, error.message, "A7878")
              );
            }
          }
        }
      } else {
        this.errorDialog(
          Errors.generalError(error.code, error.message, "A2467")
        );
      }
    });
  }

  /**
   * @returns none
   */
  public deleteCondition(): void {
    const selected_fields = this.fields[this.selected_condition];
    if (selected_fields.extends) {
      delete this.fields[this.selected_condition];
      this.selected_condition = "Default";
      this.onFind();
      this.initSelect();
      this.saveCondition();
    }
  }

  /*
   *
   */
  private trueOrFalse(s: string): boolean {
    let result: boolean = false;
    if (s) {
      result = s.toLowerCase() === "true";
    }
    return result;
  }

  private initSelectOption() {
    this.likes = [];
    this._likes.forEach((item): void => {
      this.likes.push({
        name: this.translate.instant(item.name),
        value: item.value,
      });
    });

    this.clubs = [];
    this.shotscore.clubs.forEach((item): void => {
      this.clubs.push({
        name: this.translate.instant(item.name),
        value: item.value,
      });
    });

    this.sortFields = [];
    this._sortFields.forEach((item): void => {
      this.sortFields.push({
        name: this.translate.instant(item.name),
        value: item.value,
      });
    });

    this.sortFieldsShort = [];
    this._sortFieldsShort.forEach((item): void => {
      this.sortFieldsShort.push({
        name: this.translate.instant(item.name),
        value: item.value,
      });
    });
  }

  /*
   *
   */
  public ngOnInit(): void {
    this.sort = { "platform.description.score": -1 };
    // 	super.ngOnInit();
    this.getSession((error: IErrorObject, session: object): void => {
      this.loadPanels();
      this.loadCondition();
      this.initSelect();
      this.onFind();

      this.translate.onLangChange.subscribe(() => {
        this.initSelectOption();
      });
      this.initSelectOption();
    });
  }

  /**
   * @returns none
   */
  public ngOnDestroy(): void {
    this.saveCondition();
  }

  public getSessionData(field: string): any {
    let result = null;
    const sessionData = this.currentSessionData;
    if (sessionData) {
      result = sessionData[field];
    }
    return result;
  }

  public setSessionData(
    field: string,
    data: any,
    callback: Callback<any>
  ): void {
    let sessionData: any = this.currentSessionData;
    if (!sessionData) {
      sessionData = {};
    }
    sessionData[field] = data;
    // TODO
    this.putSessionData(sessionData, (error, result: any) => {
      if (!error) {
        callback(null, data[field]);
      } else {
        callback(error, null);
      }
    });
    // 	}
  }

  /**
   * @returns none
   */
  public loadCondition(): void {
    this.fields = this.getSessionData("conditions");

    if (!this.fields) {
      this.fields = { Default: this.default_field };
    }

    // ページロードで全てのtoは未指定に戻る
    Object.keys(this.fields).forEach((key) => {
      delete this.fields[key].create.to;
    });

    this.selected_condition = this.getSessionData("selected_condition");
    if (!this.selected_condition) {
      this.selected_condition = "Default";
    }
  }

  public loadPanels(): void {
    this.conditions_panels = this.getSessionData("conditions_panels");
    if (!this.conditions_panels) {
      this.conditions_panels = {
        open_find: true,
        open_sort: true,
        open_prizm: true,
        open_sm: true,
      };
    }
  }

  /**
   * @returns none
   */
  public saveCondition(): void {}

  public savePanels(): void {
    // 	localStorage.setItem("conditions_panels", JSON.stringify(this.conditions_panels));
    this.setSessionData(
      "conditions_panels",
      this.conditions_panels,
      (error, r) => {
        if (!error) {
        }
      }
    );
  }

  public panelChange(name: string, opened: boolean): void {
    switch (name) {
      case "find":
        this.conditions_panels.open_find = opened;
        break;
      case "prizm":
        this.conditions_panels.open_prizm = opened;
        break;
      case "sm":
        this.conditions_panels.open_sm = opened;
        break;
      case "sort":
        this.conditions_panels.open_sort = opened;
        break;
      default:
    }
    this.savePanels();
  }

  /**
   *
   * ダイアログ
   * @param shot ターゲット
   */
  public viewDialog(shot: IShotView): void {
    this.get(shot._id, (error: IErrorObject, result: any): void => {
      if (!error) {
        const dialog: MatDialogRef<any> = this.matDialog.open(
          ShotdataDialogComponent,
          {
            width: "50%",
            minWidth: "320px",
            height: "fit-content",
            data: result, // {platform: result.platform, sm: result.sm, prizm: result.prizm},
            disableClose: true,
          }
        );

        dialog.afterClosed().subscribe((result: any): void => {
          if (result) {
            this.Complete("", result);
          }
        });
      } else {
        this.errorDialog(
          Errors.generalError(error.code, error.message, "A2357"),
          () => {
            this.Complete("error", error);
          }
        );
      }
    });
  }

  /**
   * デリートダイアログ
   * @param event
   * @param id
   */
  public onDelete(event: MouseEvent, id: string): void {
    const _delete = (id: string): void => {
      this.Progress(true);
      this.delete(id, (error: IErrorObject, result: any): void => {
        if (!error) {
          this.Complete("", result);
        } else {
          this.Complete("error", error);
          this.deleteErrorDialog(
            Errors.generalError(error.code, error.message, "A2368")
          );
        }
        this.Progress(false);
      });
    };

    if (event.shiftKey) {
      // dialog?
      _delete(id);
    } else {
      const resultDialogContent: any = {
        title: this.translate.instant("ショット削除"),
        message: this.translate.instant(
          "このショットを削除してもよろしいですか？"
        ),
        ok_button: this.translate.instant("はい"),
        cancel_button: this.translate.instant("いいえ"),
      };
      const dialog: MatDialogRef<any> = this.matDialog.open(
        YesNoDialogComponent,
        {
          width: "50%",
          minWidth: "320px",
          height: "fit-content",
          data: {
            session: this.currentSession,
            content: resultDialogContent,
          },
          disableClose: true,
        }
      );
      dialog.afterClosed().subscribe((result: object): void => {
        if (result) {
          // if not cancel then
          _delete(id);
        }
      });
    }
  }

  /**
   *
   */
  public onFind(): void {
    this.InitProgress();
    this.paginator.firstPage();
    this.pageIndex = 0;
    this.page = 0;
    // this.current_field = this.fields[this.selected_condition];
    this.sort = this.buildSort(this.current_field);
    this.query = this.buildQuery(this.current_field);
    this.Progress(true);
    this.draw((error: IErrorObject, accounts: object[]): void => {
      if (!error) {
        this.results = accounts;
        let configModel = _.get(this.session, "cache.configModel");
        if (configModel && !_.isEmpty(configModel)) {
          updateModel({
            model: configModel.model,
            displayParts: configModel.model_config.display_parts,
            pros: configModel.pros,
            methods: configModel.methods,
            ProPhases: configModel.ProPhases,
            DataProDetail: configModel.DataProDetail,
            ballistic: true,
            fake_advice: (configModel.fake_advice || "").toString(),
          });
          this.setHasModel();
        }
      } else {
        this.errorDialog(
          Errors.generalError(error.code, error.message, "A7439")
        );
      }
      this.Progress(false);
    });
  }

  /**
   * 再描画
   * @param related
   * @param callback コールバック
   */
  public draw(callback: Callback<object[]>): void {
    this.service.pseudo_count(
      this.query,
      this.isRelated,
      this.is_new_version,
      (error: IErrorObject, result: any): void => {
        if (!error) {
          this.count = result?.value ? result.value : typeof result === "number" ? result : result.value;
          const option: any = {
            sort: this.sort,
            skip: this.size * this.page,
            limit: this.size,
          };
          this.service.pseudo_query(
            this.query,
            option,
            this.isRelated,
            this.is_new_version,
            (error: IErrorObject, results: any[]): void => {
              if (!error) {
                const filtered: any[] = [];
                results.forEach((result: any): void => {
                  filtered.push(this.toListView(result));
                });

                callback(null, filtered);
              } else {
                callback(error, null);
              }
            }
          );
        } else {
          callback(error, null);
        }
      }
    );
  }

  public description(shot: IShotView): string {
    let result: string = "";
    if (shot) {
      if (shot.platform) {
        if (shot.platform.description) {
          result = shot.platform.description.message;
        }
      }
    }
    return result;
  }

  public isHasAdvice(_id) {
    let shot = this.results.find((x) => x._id == _id);
    if (shot) {
      return _.get(shot, "request_advice");
    }
    return null;
  }
  public saveShotMemo({ shot_id, memo }, callback) {
    this.shotsService.shotDemo(
      {
        shot_id,
        memo,
      },
      (error, data) => {
        if (data.value.code) {
          this.deleteErrorDialog(
            Errors.generalError(data.value.code, data.value.message, data.value.tag)
          );
        } else {
          callback(data);
        }
      }
    );
  }
  public onViewMemo(_id) {
    let shot = this.results.find((x) => x._id == _id);
    this.selectedShot = shot;

    let calculateDiagnoseResult = calculatePartByMesure({
      method: this.method,
      input: this.selectedShot,
      pro: null,
      csvData: null,
      user: _.get(this.session, "cache"),
    });

    let safeAreaInsetBottom =
      parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue(
          "--safe-area-inset-bottom"
        )
      ) || 0;

    let heightMemo =
      Math.min(window.innerHeight - safeAreaInsetBottom, 300) + "px";

    const dialog: MatDialogRef<any> = this.matDialog.open(
      DescriptionDialogComponent,
      {
        width: `80%`,
        height: heightMemo,
        maxHeight: "100svh",
        maxWidth: "100vw",
        data: {
          calculateDiagnoseResult,
          shot: this.selectedShot,
          size: [
            0.8 * window.innerWidth,
            (0.8 * window.innerWidth * 690) / 1150,
          ],
          // position: { x: 60, y: 210 },
          ngStyle: { "z-index": 3 },
          locked: true,
          visible: true,
          view_mode: "memo",
        },
        panelClass: "custom-description-dialog-memo",
        disableClose: true,
      }
    );

    dialog.afterClosed().subscribe((result: any): void => {
      // this.Complete("", result);
      this.selectedShot = null;
    });

    let self = this;
    dialog.componentInstance.updateMemo.subscribe((msg) => {
      if (msg.type == "save_memo") {
        console.log("got message save_memo", msg);
        self.saveShotMemo(
          {
            shot_id: msg.data.calculateDiagnoseResult.input._id,
            memo: msg.data.memo,
          },
          (data) => {
            console.log("save shot memo callback", data);
            dialog.componentInstance.updateMemo.emit({
              type: "save_memo_success",
              data,
            });
            self.updateShotData({
              isUpdate: true,
              data,
              type: "save_memo",
            });
          }
        );
      }
    });
  }

  /**
   *
   */
  public nickname(shot: IShotView): string {
    let result: string = "";
    if (shot) {
      if (shot.platform) {
        if (shot.platform.content) {
          result = shot.platform.content.nickname;
        }
      }
    }
    return result;
  }

  /**
   *
   */
  public hasPrizm(shot: IShotView): boolean {
    return Boolean(shot.prizm);
  }

  /**
   *
   */
  public name(shot: IShotView): string {
    let result: string = "";
    if (shot) {
      result = shot.name.split(":")[0];
    }
    return result;
  }

  /**
   *
   */
  public clubNo(shot: IShotView): number {
    let result: number = 0;
    if (shot) {
      if (shot.platform) {
        if (shot.platform.description) {
          result = shot.platform.description.club;
        }
      }
    }
    return result;
  }

  /**
   *
   */
  public clubName(shot: IShotView): string {
    let result: string = "";
    if (shot) {
      if (shot.platform) {
        if (shot.platform.description) {
          const clubValue = shot.platform.description.club;
          if (
            clubValue &&
            this.shotscore.clubs &&
            this.shotscore.clubs.length > 0
          ) {
            const club = this.shotscore.clubs.find(
              (club) => club.value === clubValue
            );
            if (club) {
              result = club.name;
            } else {
              // Fallback to club number if not found in clubs array
              result = `${clubValue}I`;
            }
          }
        }
      }
    }
    return result;
  }

  /**
   *
   */
  public score(shot: IShotView): string {
    let result: string = "0";
    if (shot) {
      if (shot.platform) {
        if (shot.platform.description) {
          if (shot.platform.description.score) {
            result = Math.floor(shot.platform.description.score).toString();
          }
        }
      }
    }
    return result;
  }

  /**
   * undef guard
   *
   * @param shot shot
   *
   * @returns boolean isown
   */
  public own(shot: IShotView): boolean {
    let result: boolean = false;
    if (shot) {
      result = true; // shot.isown;
    }
    return result;
  }

  /**
   * todo
   */
  public scoreStyle(shot: IShotView): any {
    let result: any = { color: "rgba(40,40,40,0.5)" };
    if (shot.platform) {
      if (shot.platform.description) {
        if (shot.platform.description.message !== "") {
          result = { color: "rgba(149,8,8,0.5)" };
        }
      }
    }
    return result;
  }

  /**
   * recalc score
   *
   * @param shot shot
   *
   * @returns none
   */
  public fixScore(shot: IShotView): void {
    this.get(shot._id, (error: IErrorObject, result: any): void => {
      if (!error) {
        // 	shot.platform.description.score = this.shotscore.score(shot);

        // TODO: score
        const postureScore = this.shotscore.postureScore(shot);
        const ballisticScore = this.shotscore.ballisticScore(shot);

        shot.platform.description.postureScore = postureScore;
        shot.platform.description.ballisticScore = ballisticScore;

        if (ballisticScore) {
          shot.platform.description.score = (ballisticScore + postureScore) / 2;
        } else {
          shot.platform.description.score = postureScore;
        }

        // 	shot.platform.description.score = (this.shotscore.ballisticScore(shot) + this.shotscore.postureScore(shot)) / 2;

        this.update(
          shot._id,
          shot,
          (error: IErrorObject, result: any): void => {
            if (!error) {
              this.Progress(true);
              this.draw((error: IErrorObject, accounts: object[]): void => {
                if (!error) {
                  this.results = accounts;
                } else {
                  this.errorDialog(
                    Errors.generalError(error.code, error.message, "A2767")
                  );
                }
                this.Progress(false);
              });
            } else {
              this.errorDialog(
                Errors.generalError(error.code, error.message, "A2887")
              );
            }
          }
        );
      } else {
        this.errorDialog(
          Errors.generalError(error.code, error.message, "A2391")
        );
      }
    });
  }

  /**
   * @returns none
   */
  public onUpdateShot(event: any): void {
    this.infoUpdateDialog(event, (error, result): void => {
      if (!error) {
        this.Progress(true);
        this.current_field = this.fields[this.selected_condition];
        this.sort = this.buildSort(this.current_field);
        this.query = this.buildQuery(this.current_field);
        this.draw((error, result) => {
          if (error) {
            this.errorDialog(
              Errors.generalError(error.code, error.message, "A0365")
            );
          }
          this.Progress(false);
        });
      } else {
        this.errorDialog(
          Errors.generalError(error.code, error.message, "A2327")
        );
      }
    });
  }

  /**
   * @returns none
   */
  public infoUpdateDialog(
    shot: any,
    callback: (error: IErrorObject, result: any) => void
  ): void {
    const dialog: MatDialogRef<any> = this.matDialog.open(UpdateListComponent, {
      width: "50%",
      minWidth: "320px",
      height: "fit-content",
      data: shot,
      disableClose: true,
    });

    dialog.beforeClosed().subscribe((result: any): void => {
      if (result) {
        // if not cancel then
        const id: string = shot._id;

        // shot.platform.description.score = this.shotscore.score(shot);

        // TODO: score
        const postureScore = this.shotscore.postureScore(shot);
        const ballisticScore = this.shotscore.ballisticScore(shot);

        shot.platform.description.postureScore = postureScore;
        shot.platform.description.ballisticScore = ballisticScore;

        if (ballisticScore) {
          shot.platform.description.score = (ballisticScore + postureScore) / 2;
        } else {
          shot.platform.description.score = postureScore;
        }

        this.update(
          id,
          this.confirmToModel(shot),
          (error: IErrorObject, result: any): void => {
            if (!error) {
              callback(null, result);
            } else {
              callback(error, null);
            }
          }
        );
      }
    });

    dialog.afterClosed().subscribe((result: any): void => {
      callback(null, result);
    });
  }

  /**
   * undef guard
   *
   * @param item shot
   *
   * @returns boolean isPublic
   */
  public isPublic(shot: IShotView): number {
    let result: number = 0;
    if (shot) {
      if (shot.platform) {
        if (shot.platform.scope) {
          result = shot.platform.scope;
        }
      }
    }
    return result;
  }

  /**
   * undef guard
   *
   * @param shot shot
   *
   * @returns message
   */
  public message(shot: IShotView): string {
    let result: string = "";
    if (shot) {
      if (shot.platform) {
        if (shot.platform.description) {
          if (shot.platform.description.message) {
            result = shot.platform.description.message;
          }
        }
      }
    }
    return result;
  }

  public updateShotData(msg) {
    console.log("trigger updateShotData", msg);
    if (msg.isUpdate && _.get(msg, "data.value.updated_shot")) {
      let updatedShot = JSON.parse(JSON.stringify(msg.data.value.updated_shot));

      let shotIdx = this.results.findIndex((x) => x._id == updatedShot._id);
      if (shotIdx > -1) {
        this.results[shotIdx] = updatedShot;
      }

      if (this.selectedShot._id == updatedShot._id) {
        this.selectedShot = updatedShot;
      }
      this.updateOnDetailData(msg.type);
    }
  }

  public setHasModel() {
    this.isHasModel = true;
    this.query = this.buildQuery(this.current_field);
  }
  public updateOnDetailData(type) {
    if (this.selectedShot) {
      if (this.matDialogRef) {
        this.matDialogRef.componentInstance.inputChange.emit({
          ...this.matDialogRef.componentInstance.data,
          shot: this.selectedShot,
          type,
        });
      }
    }
  }

  public onDetail(shot: any): void {
    let breakpoint = 320;
    let width = "100%";
    let max_width = "100vw";
    let height = "100%";
    let shotData = { shot: shot, isDelete: false };
    this.selectedShot = shot;
    const dialog: MatDialogRef<any> = this.matDialog.open(
      ShotdataDialogComponent,
      {
        // width: "80%",
        width: width,
        maxWidth: max_width,
        // height: height,
        // minWidth: "320px",
        height: height,
        data: {
          ...shotData,
          user: _.get(this.session, "cache"),
          method: this.method,
        }, // {platform: result.platform, sm: result.sm, prizm: result.prizm},
        disableClose: true,
        //		panelClass: "shotdatad_dialog_comp",
        autoFocus: false,
      }
    );

    this.matDialogRef = dialog;

    let self = this;

    dialog.componentInstance.updateShot.subscribe((msg) => {
      self.updateShotData(msg);
    });

    dialog.afterClosed().subscribe((result: any): void => {
      if (shotData.isDelete) {
        this.draw((error: IErrorObject, accounts: object[]): void => {
          if (!error) {
            this.results = accounts;
          } else {
            this.errorDialog(
              Errors.generalError(error.code, error.message, "A7438")
            );
          }
        });
      }
      this.Complete("", result);
      this.selectedShot = null;
      this.matDialogRef = null;
    });
  }

  public onDetailShotAvg(shot: any): void {
    let breakpoint = 320;
    let width = "100%";
    let max_width = "100vw";
    let height = "100%";
    let shotData = { shot: shot, isDelete: false };
    this.selectedShot = shot;
    const dialog: MatDialogRef<any> = this.matDialog.open(
      ShotdataAvgDialogComponent,
      {
        // width: "80%",
        width: width,
        maxWidth: max_width,
        // height: height,
        // minWidth: "320px",
        height: height,
        data: {
          ...shotData,
          user: _.get(this.session, "cache"),
          method: this.method,
        }, // {platform: result.platform, sm: result.sm, prizm: result.prizm},
        disableClose: true,
        //		panelClass: "shotdatad_dialog_comp",
        autoFocus: false,
      }
    );

    this.matDialogRef = dialog;

    let self = this;

    dialog.componentInstance.updateShot.subscribe((msg) => {
      self.updateShotData(msg);
    });

    dialog.afterClosed().subscribe((result: any): void => {
      if (shotData.isDelete) {
        this.draw((error: IErrorObject, accounts: object[]): void => {
          if (!error) {
            this.results = accounts;
          } else {
            this.errorDialog(
              Errors.generalError(error.code, error.message, "A7438")
            );
          }
        });
      }
      this.Complete("", result);
      this.selectedShot = null;
      this.matDialogRef = null;
    });
  }

  public onResize(): void {}

  /**
   *
   */
  public getLike(shot: IShotView): boolean {
    let result: boolean = false;
    if (shot) {
      if (shot.platform) {
        if (shot.platform.description) {
          if (shot.platform.description.like) {
            result = shot.platform.description.like;
          }
        }
      }
    }
    return result;
  }

  protected deleteErrorDialog(
    error: IErrorObject,
    callback: (result: any) => void = (error: IErrorObject) => {}
  ): void {
    if (error) {
      const dialog: MatDialogRef<any> = this.matDialog.open(
        MessageDialogComponent,
        {
          width: "30%",
          minWidth: "320px",
          height: "fit-content",
          data: {
            content: {
              title: "Error.",
              message: error.message.replace(/。/g, "。<br>"),
              tag: error.tag,
            },
          },
          disableClose: true,
        }
      );

      dialog.afterClosed().subscribe((result: any): void => {
        callback(result);
        window.location.reload();
      });
    }
  }



  public setLike(shot: IShotView): void {
    const id: string = shot._id;
    const originalLikeState = shot.platform.description.like;
    shot.platform.description.like = !shot.platform.description.like;

    this.update(
      id,
      this.confirmToModel(shot),
      (error: IErrorObject, result: any): void => {
        if (!error) {
        } else {
          shot.platform.description.like = originalLikeState;
		 if (error.code === 100) {
			this.errorDialog(error);
		 } else {
			this.deleteErrorDialog(error);
		 }
        }
      }
    );
  }

  /**
   * @param event イベント
   */
  @HostListener("dragover", ["$event"])
  public onDragOver(event: any): void {
    event.preventDefault();
  }

  /**
   * @param event イベント
   */
  @HostListener("drop", ["$event"])
  public onDrop(event: any): void {
    event.preventDefault();
    if (event.dataTransfer.items[0].type === "text/plain") {
      this.uploadfile = event.dataTransfer.files[0].path;
    }
  }

  public Page(event: any): void {
    super.Page(event);
    this.pageIndex = event.pageIndex;
  }

  public onSelectAVGShotOrigin = (shot) => {
    if (this.isAvgInputShot(shot)) {
      this.selectedAvgInputShots = this.selectedAvgInputShots.filter(
        (x) => x._id != shot._id
      );
    } else {
      this.selectedAvgInputShots.push(shot);
    }

    console.log(
      "selectedAvgInputShots",
      this.selectedAvgInputShots.length,
      this.selectedAvgInputShots
    );
  };

  public onResetSelectAvgShotOrigin = () => {
    console.log("onResetSelectAvgShotOrigin");
    this.selectedAvgInputShots = [];
  };

  public onToggleLike = (event: any) => {
    console.log("onToggleLike");
    this.current_field.like = event.checked ? "1" : "0";
    this.onResetSelectAvgShotOrigin();
  };

  public isAvgShot = (shot) => {
    return _.get(shot, "platform.description.avg_shot");
  };

  public isAvgInputShot = (shot) => {
    return this.selectedAvgInputShots.find((x) => x._id == shot._id);
  };

  public isValigInputAVGShot = (shot) => {
    if (this.isAvgShot(shot)) return false;

    if (!this.selectedAvgInputShots.length) return true;

    let firstShot = _.first(this.selectedAvgInputShots);
    return (
      _.get(shot, "platform.description.club") ==
      _.get(firstShot, "platform.description.club")
    );
  };

  private fnCreateAVGShot = () => {
    console.log("fnCreateAVGShot");
    let firstShot = _.first(this.selectedAvgInputShots);
    let avgShot = _.cloneDeep(firstShot);
    delete avgShot._id;
    delete avgShot.platform.content.stripe_id;
    delete avgShot.time_request_advice;
    delete avgShot.request_advice;

    avgShot.memo = "";
    avgShot.name = moment().format("YYYY-MM-DD");
    avgShot.platform.description.avg_shot = true;
    avgShot.platform.description.like = true;

    let club = avgShot.platform.description.club;

    let partNames = getSmParts();

    let attrs = [
      {
        field: "platform.description.score",
        field2: "",
        type: "avg",
        round: 2,
      },
      {
        field: "platform.description.postureScore",
        field2: "",
        type: "avg",
        round: 2,
      },
      {
        field: "platform.description.ballisticScore",
        field2: "",
        type: "avg",
        round: 2,
      },
      ..._.flattenDeep(
        partNames.map((x) =>
          [
            "address",
            "backswing",
            "top",
            "halfdown",
            "impact",
            "follow",
            "finish",
          ].map((y) => [
            {
              field: ["sm", x, y, "metrics"],
              type: "avg",
              round: null,
            },
            {
              field: ["sm", x, y, "frame"],
              field2: ["sm", x, y, "frames"],
              type: "array",
              round: null,
            },
          ])
        )
      ),
    ];

    for (let i = 0; i < attrs.length; i++) {
      const attrData = attrs[i];
      switch (attrData.type) {
        case "avg":
          let field = attrData.field2 || attrData.field;
          let avgValue = _(this.selectedAvgInputShots)
            .map((x) => _.get(x, attrData.field))
            .mean();

          if (attrData.round) {
            avgValue = _.round(avgValue, attrData.round);
          }
          _.set(avgShot, field, avgValue);

          break;

        case "array":
          let values = _(this.selectedAvgInputShots)
            .map((x) => _.get(x, attrData.field))
            .value();
          _.set(avgShot, attrData.field2, values);

          break;
        default:
          break;
      }
    }

    let parts = getAvgParts()[club];

    return { shot: avgShot, parts };
  };

  public onConfirmCreateShotAVG(): void {
    console.log("onConfirmCreateShotAVG");
    let { shot, parts } = this.fnCreateAVGShot();

    let breakpoint = 320;
    let width = "900px";
    let max_width = "100vw";
    let height = "100%";
    let shotData = { shot: shot, isDelete: false };
    this.selectedShot = shot;
    const dialog: MatDialogRef<any> = this.matDialog.open(
      ConfirmCreateShotAvgDialogComponent,
      {
        // width: "80%",
        width: width,
        maxWidth: max_width,
        // height: height,
        // minWidth: "320px",
        // height: height,
        data: {
          ...shotData,
          parts,
          user: _.get(this.session, "cache"),
          method: this.method,
        }, // {platform: result.platform, sm: result.sm, prizm: result.prizm},
        disableClose: true,
        //		panelClass: "shotdatad_dialog_comp",
        autoFocus: false,
      }
    );

    this.matDialogRef = dialog;

    dialog.componentInstance.updateShot.subscribe((msg) => {
      console.log("updateShot", msg);
      this.service.shotAVG(msg.data, (error, data) => {
        console.log("callback shotAVG", "error", error, "data", data);
        this.selectedAvgInputShots = [];
        if (!error) {
          console.log("TODO dialog shotAVG success");
          this.onFind();
          dialog.close();
        } else {
          this.errorDialog(Errors.generalError(error.code, error.message, "9"));
        }
      });
    });

    dialog.afterClosed().subscribe((result: any): void => {
      this.Complete("", result);
      this.selectedShot = null;
      this.matDialogRef = null;
    });
  }
}
